import { render, staticRenderFns } from "./active_duration.vue?vue&type=template&id=ca1d398e&scoped=true"
import script from "./active_duration.vue?vue&type=script&lang=ts"
export * from "./active_duration.vue?vue&type=script&lang=ts"
import style0 from "./active_duration.vue?vue&type=style&index=0&id=ca1d398e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1d398e",
  null
  
)

export default component.exports